import { appGlobe01Icon } from './globe-01';
import { appRulerIcon } from './ruler';
import { appStandIcon } from './stand';
export const educationIcons = [appGlobe01Icon, appRulerIcon, appStandIcon];
